import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {CounselingInductionService} from "../counseling-induction.service";
import {PermissionType} from "../../../../../components/employee/PermissionType.enum";
import {LogService} from "../../../../../services/log.service";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {EmployeeService} from "../../../../../services/employee.service";
import {Timestamp} from "firebase/firestore";
import {MatSort} from "@angular/material/sort";
import {FinancialYearService} from "../../../../../services/financial-year.service";

@Component({
  selector: 'app-counselling-induction-list',
  templateUrl: './counselling-induction-list.component.html',
  styleUrls: ['./counselling-induction-list.component.scss']
})
export class CounsellingInductionListComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  displayedColumns = ['sr', 'inductionFor', 'submittedBy', 'createdAt', 'actions'];
  dataSource = new MatTableDataSource<any>([]);
  start: Date | null = null;
  end: Date | null = null;
  counsellors$: Observable<any[]>
  submittedBy: any[] = [];
  isLoading = false;
  allCounsellingInduction: any[] = [];
  today: Date = new Date();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private inductionService: CounselingInductionService,
    private router: Router,
    private mLogService: LogService,
    private readonly mEmployeeService: EmployeeService,
    private readonly financialYearService: FinancialYearService,
  ) {
    this.counsellors$ = this.mEmployeeService.getCounsellers()
  }

  ngOnInit() {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.start = fy.startDate;
    this.end = fy.endDate;

    this.inductionService.getAll().pipe(takeUntil(this._destroyed$)).subscribe(data => {
      this.allCounsellingInduction = data;
      this.dataSource.data = data;
      this.dataSource.paginator = this.paginator;
    });
  }

  applyFilter(event: any) {
    let filterValue = event.target.value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }


  DeleteInduction(id: string) {
    if (!confirm("Are you sure you want to delete?")) return;
    this.inductionService.delete(id);
    const activity = {
      date: new Date().getTime(),
      section: 'Counselling Induction',
      action: 'Deleted',
      description: `Counselling Induction details deleted by user`,
      currentIp: localStorage.getItem('currentip')!
    };
    this.mLogService.addLog(activity);
  }
  AddInductions(){
    this.router.navigate(['/home/counseling/add-edit-counselling-induction']);
  }
  EditInduction(id: string) {
    this.router.navigate(['/home/counseling/add-edit-counselling-induction', id]);
  }

  viewInduction(id: string) {
    this.router.navigate(['/home/counseling/view-induction', id]);
  }

  search() {
    this.isLoading = true;

    const from = this.start
      ? new Date(new Date(this.start).setHours(0, 0, 0, 0))
      : null;

    const to = this.end
      ? new Date(new Date(this.end).setHours(23, 59, 59, 999))
      : null;

    let filtered = [...this.allCounsellingInduction];

    if (this.submittedBy && this.submittedBy.length > 0) {
      const selectedNames = this.submittedBy.map(c => c.userName);
      filtered = filtered.filter(item => selectedNames.includes(item.submittedBy));
    }

    if (from && to) {
      filtered = filtered.filter(item => {
        const itemDate =
          item.createdAt instanceof Timestamp
            ? item.createdAt.toDate()
            : null;
        return itemDate && itemDate >= from && itemDate <= to;
      });
    }

    this.dataSource = new MatTableDataSource(filtered);
    this.dataSource.sort = this.sort!;
    this.dataSource.paginator = this.paginator!;
    this.paginator?.firstPage();

    this.isLoading = false;
  }

  onSearch() {
    this.search();
  }

  onClear() {
    this.submittedBy = [];
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.start = fy.startDate;
    this.end = fy.endDate;
    this.dataSource = new MatTableDataSource(this.allCounsellingInduction);
    this.dataSource.sort = this.sort!;
    this.dataSource.paginator = this.paginator!;
  }

  protected readonly PermissionType = PermissionType;

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
